import { PullRequest } from '../../../../../../models/CommentHistory';
import { PullRequest as ApiPullRequest } from '../../Models/ApiResponse';

export function toPullRequest(pullrequest: ApiPullRequest): PullRequest {
  return {
    ...pullrequest,
  };
}
